import { Component, OnInit, OnDestroy, EventEmitter, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

import { Agent, ResourcesProvider } from 'core/models';
import {
  AgentsService,
  ClientsService,
  GroupsService,
  ProfileService,
  StudentsService,
  UiService
} from 'core/services';

@Component({
  selector: 'lms-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
  public profileSubscription: Subscription;
  user: Agent;
  resourcesProviders: ResourcesProvider[] = [];
  @Output() public showCookies: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    public translate: TranslateService,
    public profileService: ProfileService,
    public agentsService: AgentsService,
    public clientsService: ClientsService,
    public groupsService: GroupsService,
    public studentsService: StudentsService,
    public uiService: UiService
  ) {}

  public ngOnInit(): void {
    this.profileSubscription = this.profileService.getLoggedUser$().subscribe((user) => {
      this.user = user;
      this.resourcesProviders = this.getResourcesProviders();
    });
  }

  getResourcesProviders() {
    const resourcesProvidersArray: ResourcesProvider[] = [
      {
        service: this.clientsService,
        data: [],
        route: '/clients',
        icon: 'glicon-clients'
      },
      {
        service: this.groupsService,
        data: [],
        route: '/groups',
        icon: 'glicon-class'
      },
      {
        service: this.studentsService,
        data: [],
        route: '/students',
        icon: 'glicon-student'
      }
    ];
    return resourcesProvidersArray;
  }

  public ngOnDestroy(): void {
    this.profileSubscription.unsubscribe();
  }

  public showCookiesConfig(event: boolean): void {
    this.showCookies.emit(event);
  }
}
